var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onboarding-quicktrial__signup" },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c("header", [
        _c(
          "p",
          {
            class: [
              "onboarding-quicktrial__signup-title",
              _vm.isDesktop
                ? "typographies-display-medium"
                : "typographies-display-small"
            ]
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__("pages.onboarding.trial.OnboardingQuicktrial.title")
                ) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "onboarding-quicktrial__signup-form",
              attrs: {
                rules: _vm.rules,
                labelPosition: "top",
                inlineMessage: "",
                model: _vm.form
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.professional_email"),
                    disabled: "",
                    prop: "login",
                    error: _vm.errors.get("login")
                  }
                },
                [
                  _c("CompassInput", {
                    attrs: {
                      size: _vm.componentSize,
                      type: "email",
                      disabled: ""
                    },
                    model: {
                      value: _vm.form.login,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "login", $$v)
                      },
                      expression: "form.login"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.your_company_name"),
                    prop: "name",
                    error: _vm.errors.get("name")
                  }
                },
                [
                  _c("CompassInput", {
                    attrs: { size: _vm.componentSize },
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.phone"),
                    prop: "phone_number",
                    error: _vm.errors.get("phone_number")
                  }
                },
                [
                  _c("CompassTelInput", {
                    attrs: {
                      value: _vm.form.phone_number,
                      defaultCountry: _vm.form.phone_country.toLowerCase(),
                      size: _vm.componentSize
                    },
                    on: {
                      validate: _vm.updatePhoneNumber,
                      onBlur: _vm.onBlurTelInput,
                      "country-changed": _vm.updatePhoneCountry
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("CompassCheckbox", {
                    attrs: {
                      modelValue: "mailing",
                      label: _vm.$t.__(
                        "pages.onboarding.trial.OnboardingQuicktrial.mailing_label"
                      ),
                      checked: _vm.form.mailing
                    },
                    on: {
                      change: function() {
                        _vm.form.mailing = !_vm.form.mailing
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("p", {
                staticClass:
                  "onboarding-quicktrial__signup-form-terms typographies-paragraph-medium-regular",
                domProps: { innerHTML: _vm._s(_vm.termsLabelLegalInformation) }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "onboarding-quicktrial__signup-form-item",
                attrs: {
                  label: _vm.$t.__("common.actions.create_account"),
                  type: "primary",
                  size: _vm.componentSize
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.submitForm("form", "signup")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", {
            staticClass:
              "onboarding-quicktrial__signup-terms typographies-paragraph-small-regular",
            domProps: { innerHTML: _vm._s(_vm.legalsTerms) }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }